import classes from './sceErrorBox.scss';
import ScePasswordErrorDisplay from './scePasswordError.js';
import ReactHtmlParser from 'react-html-parser';
import AnchorTag from '../../CommonComponents/CustomAnchorTag/customAnchorTag.js';
import { getLocalizedStrings } from '../../../IncomeQualifiedProgram/IQPCommon/IQPCommonLocalizedStrings';

const SceErrorBox = function (props) {
  const IQPErrors = getLocalizedStrings('inlineErrors');
  const errLink = props.errDetails && props.errDetails.errLink ? props.errDetails.errLink : '';
  const billLink = props.showBillLink ? <AnchorTag linkName={props.seeBillLnk} onClick={props.handleSearchInfo} isUnderline />: null;
  const errorDisp = props.isError ? <div className={[classes.sceFieldAlert].join(' ')} role='region' aria-live='assertive' tabIndex='0' aria-describedby={props.type} aria-invalid={app.appUtil.getAppConstants().FALSE} >
    <span>
      <i disabled="disabled" aria-hidden className='fas fa-exclamation-circle fa-lg inValid' />
      <span className="sr-only">Error</span>
    </span>
    <span className={drupalSettings.custom.globalInformation.isFront === true ? classes.hpsceAlertText : classes.sceAlertText}>{props.languageTranslations ? IQPErrors[props.errorMessage] : props.errorMessage}<span className={classes.errorLink}>{ReactHtmlParser(errLink)}</span><div className={classes.sceSeeBillDiv}>{billLink}</div></span>
  </div> : null;
  const pwdErrDisplay = (props.type === 'newPassword') && (props.isTouched || (props.isError && !props.forceValidate)) ?
    <ScePasswordErrorDisplay errDetails={props.errDetails} /> : null;
  return (
    <div>
      {errorDisp}
      {/* Section to display password error validator display*/}
      {pwdErrDisplay}
    </div>

  );
};

export default SceErrorBox;
